module.exports = __webpack_public_path__ + "static/img/新零售云货架系统.560395f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/新零售云货架系统.png
// module id = 29ia
// module chunks = 45